export const UrlConstants = {

    BASE_URL: process.env.REACT_APP_BASE_URL,
    API_VERSION: "1.0"
};

export const AppConfig = {
    RIGHT_CLICK_DISABLED : false
}

export const WebViewUserAgent = "mobile_app_webview";
